'use client';

import React, { useState } from 'react';
import {
    Box, Typography, TextField, Button, InputAdornment,
    IconButton, Alert, useTheme
} from '@mui/material';
import { Visibility, VisibilityOff, LockOutlined, ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../services/api-client';
import { useAuthStore } from '../../../store/useAuthStore';
import { toast } from 'sonner';

export function ChangePasswordPage() {
    const navigate = useNavigate();
    const [passwords, setPasswords] = useState({ old: '', new: '', confirm: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { user } = useAuthStore();
    const setMustChangePassword = useAuthStore((state) => state.setMustChangePassword);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!user || !user.id) {
            setError("Erreur : session utilisateur non trouvée. Veuillez vous reconnecter.");
            return;
        }

        if (passwords.new !== passwords.confirm) {
            setError("Les nouveaux mots de passe ne correspondent pas.");
            return;
        }

        setLoading(true);
        try {
            await apiClient.post('/api/auth/change-password', {
                userId: user.id,
                oldPassword: passwords.old,
                newPassword: passwords.new
            });

            // setMustChangePassword(false);

            toast.success("Mot de passe modifié avec succès !");

            useAuthStore.logout();

            // 2. Rediriger vers le login
            navigate('/login', { replace: true });
        } catch (err) {
            setError(err.response?.data?.message || "Erreur lors de la modification.");
        } finally {
            setLoading(false);
        }
    };

    const inputSx = {
        '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            '&.Mui-focused fieldset': { borderColor: '#c9a84c' },
        },
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', bgcolor: '#fafaf8' }}>
            <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', maxWidth: 400, p: 4, bgcolor: 'white', borderRadius: 4, boxShadow: '0 10px 25px rgba(0,0,0,0.05)' }}>
                <Typography variant="h5" sx={{ mb: 1, fontFamily: "'Cormorant Garamond', serif", fontWeight: 700, color: '#1a1a2e' }}>
                    Changement de mot de passe
                </Typography>
                <Typography variant="body2" sx={{ mb: 3, color: '#666' }}>
                    Votre mot de passe actuel doit être modifié pour des raisons de sécurité.
                </Typography>

                {error && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{error}</Alert>}

                <TextField
                    fullWidth label="Ancien mot de passe" type={showPassword ? 'text' : 'password'}
                    value={passwords.old} onChange={(e) => setPasswords({ ...passwords, old: e.target.value })}
                    sx={{ mb: 2, ...inputSx }} required
                />

                <TextField
                    fullWidth label="Nouveau mot de passe" type={showPassword ? 'text' : 'password'}
                    value={passwords.new} onChange={(e) => setPasswords({ ...passwords, new: e.target.value })}
                    sx={{ mb: 2, ...inputSx }} required
                />

                <TextField
                    fullWidth label="Confirmer le nouveau mot de passe" type={showPassword ? 'text' : 'password'}
                    value={passwords.confirm} onChange={(e) => setPasswords({ ...passwords, confirm: e.target.value })}
                    sx={{ mb: 3, ...inputSx }} required
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                <Button
                    type="submit" fullWidth disabled={loading}
                    sx={{
                        height: 50, borderRadius: '12px', bgcolor: '#1a1a2e', color: 'white',
                        '&:hover': { bgcolor: '#c9a84c' }
                    }}
                >
                    {loading ? 'Chargement...' : 'Modifier le mot de passe'}
                </Button>
            </Box>
        </Box>
    );
}